import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.NL30};
  background-color: ${({ theme }) => theme.palette.NL0};
  display: flex;
  min-height: 210px;
`;

export const ImageWrapper = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
`;

export const TitleContent = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;

  & span {
    font-weight: normal;
  }
  .rc-tooltip-arrow {
    display: none;
  }
`;

export const DescriptionWrapper = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EventsDatesWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.NL20};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
`;

export const FlexDatesWrapper = styled.div<{ hasHover?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: ${({ hasHover }) => (hasHover ? 'pointer' : 'default')};
`;

export const DetailsInfo = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  position: absolute;
  bottom: 12px;
  right: 16px;
  cursor: pointer;

  & span {
    text-decoration: underline;
  }
`;
